// import { useEffect, useState } from "react";
// import { useUser } from "../../UserContext";

// const trackClick = () => {
//     fetch(`https://tools.empreender.com.br/produtos-empreender-click?app=GENERIC&origem=empreender_ui_banner_click`, {
//         method: 'POST',
//     });
// };

const EventHeader = () => {
    // const [isVisible, setIsVisible] = useState(true);
    // const { hideApps } = useUser();

    // useEffect(() => {
    //     const checkExpiration = () => {
    //         const now = new Date();

    //         const expirationDate = new Date(2026, 2, 10, 18, 0, 0);

    //         if (now >= expirationDate) {
    //             setIsVisible(false);
    //         }
    //     };

    //     checkExpiration();
    // }, []);

    // if (!isVisible) return null;

    // if (hideApps) return null;

    return (
        <>
        </>
        // <div className="w-full flex items-center justify-center select-none mt-2">
        //     <a
        //         onClick={trackClick}
        //         href="https://luma.com/bootcamp-lpi"
        //         className="select-none"
        //         target="_blank"
        //         rel="noopener noreferrer"
        //     >
        //         <img
        //             src="https://empreender.nyc3.digitaloceanspaces.com/LP/im/9ab67785a1ec.png"
        //             draggable={false}
        //             alt="Evento Bootcamp"
        //         />
        //     </a>
        // </div>
    );
};

export default EventHeader;